import { Link } from "@tanstack/react-router";
import { CALENDLY_URL } from "@/lib/site";
import { trackScheduleConsultation } from "@/lib/analytics";

import { Logo } from "./Logo";

export function Footer() {
  return (
    <footer className="border-t border-brand-navy/10 bg-brand-surface">
      <div className="mx-auto max-w-7xl px-6 py-16">
        <div className="grid gap-12 md:grid-cols-3 lg:grid-cols-5">
          <div>
            <Logo markClassName="size-7" wordClassName="text-base" />

            <p className="mt-4 max-w-xs text-sm leading-relaxed text-brand-navy/60">
              Dedicated US bookkeeping starting from $199/mo and institutional finance operations
              for startups and growing SMBs.
            </p>

            <div className="mt-4 inline-flex items-center gap-2 rounded-xl border border-brand-navy/10 bg-background px-3 py-1.5 text-xs font-semibold text-brand-navy/80">
              <span className="size-2 rounded-full bg-emerald-500" />
              Certified QuickBooks ProAdvisor
            </div>
          </div>

          <div>
            <h2 className="text-xs font-bold uppercase tracking-widest text-brand-navy">
              Services
            </h2>
            <ul className="mt-6 space-y-3 text-sm text-brand-navy/60">
              <li>
                <Link to="/services/bookkeeping" className="hover:text-brand-accent font-semibold text-brand-navy/90">
                  Bookkeeping (from $199/mo)
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-brand-accent">
                  Payroll Processing
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-brand-accent">
                  AP & AR Management
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-brand-accent">
                  CFO & Controller Support
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="text-xs font-bold uppercase tracking-widest text-brand-navy">
              Industries
            </h2>
            <ul className="mt-6 space-y-3 text-sm text-brand-navy/60">
              <li>
                <Link
                  to="/industries/startups"
                  className="hover:text-brand-accent font-semibold text-brand-navy/90"
                >
                  Startups (Pre-seed to Series A)
                </Link>
              </li>
              <li>
                <Link to="/industries/saas" className="hover:text-brand-accent">
                  SaaS & Technology
                </Link>
              </li>
              <li>
                <Link to="/industries/ecommerce" className="hover:text-brand-accent">
                  E-Commerce & DTC
                </Link>
              </li>
              <li>
                <Link to="/industries/professional-services" className="hover:text-brand-accent">
                  Agencies & Consultancies
                </Link>
              </li>
              <li>
                <Link to="/industries/cross-border-india-us" className="hover:text-brand-accent">
                  India→US Cross-Border
                </Link>
              </li>
              <li>
                <Link to="/industries/nonprofits" className="hover:text-brand-accent">
                  Nonprofits & Research
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="text-xs font-bold uppercase tracking-widest text-brand-navy">Company</h2>
            <ul className="mt-6 space-y-3 text-sm text-brand-navy/60">
              <li>
                <Link to="/about" className="hover:text-brand-accent">
                  About Finendra
                </Link>
              </li>
              <li>
                <Link to="/how-it-works" className="hover:text-brand-accent">
                  How It Works
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="hover:text-brand-accent">
                  Pricing & Plans
                </Link>
              </li>
              <li>
                <Link to="/careers" className="hover:text-brand-accent">
                  Careers
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-brand-accent">
                  Contact
                </Link>
              </li>
              <li>
                <a
                  href={CALENDLY_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => trackScheduleConsultation("footer")}
                  data-analytics-location="footer"
                  className="hover:text-brand-accent"
                >
                  Schedule Consultation
                </a>
              </li>
              <li>
                <a href="mailto:connect@finendra.com" className="hover:text-brand-accent">
                  connect@finendra.com
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="text-xs font-bold uppercase tracking-widest text-brand-navy">
              Resources
            </h2>
            <ul className="mt-6 space-y-3 text-sm text-brand-navy/60">
              <li>
                <Link to="/blog" className="hover:text-brand-accent">
                  Insights & Guides
                </Link>
              </li>
              <li>
                <Link to="/faq" className="hover:text-brand-accent">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/security" className="hover:text-brand-accent">
                  Security & Data
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="hover:text-brand-accent">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="hover:text-brand-accent">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-brand-navy/10 pt-6 text-xs leading-relaxed text-brand-navy/50">
          <p>
            Disclaimer: Finendra is a financial operations, bookkeeping, and controller support
            firm. We are not a licensed public CPA firm and do not provide independent attest
            services or legal counsel. We prepare GAAP-aligned workpapers and collaborate directly
            with your licensed CPA for annual corporate tax filings.
          </p>
        </div>

        <div className="mt-6 flex flex-col items-center justify-between gap-4 border-t border-brand-navy/10 pt-6 text-sm text-brand-navy/70 md:flex-row">
          <p>© {new Date().getFullYear()} Finendra. All rights reserved.</p>
          <p>Global finance and accounting operations.</p>
        </div>
      </div>
    </footer>
  );
}
